import { render, staticRenderFns } from "./SelectDialog.vue?vue&type=template&id=25707606&scoped=true&"
import script from "./SelectDialog.vue?vue&type=script&lang=js&"
export * from "./SelectDialog.vue?vue&type=script&lang=js&"
import style0 from "./SelectDialog.vue?vue&type=style&index=0&id=25707606&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25707606",
  null
  
)

export default component.exports